import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: "existInsurance" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "text-left"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg ja eller nej'
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: "existInsuranceLabel",
  class: "pb-3 text-left",
  textContent: 'Hvilket forsikringsselskab var du senest hos?'
}
const _hoisted_7 = {
  class: "pb-3 pt-3 text-left",
  textContent: 'Hvornår skal forsikringen gælde fra?',
  key: "validNowLabel"
}
const _hoisted_8 = { key: "validNow" }
const _hoisted_9 = {
  key: 0,
  class: "text-left"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg en af ovenstående'
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "pb-3 pt-3 text-left",
  textContent: 'Hvor mange forsikringsskader har du haft de seneste 2 år?'
}, null, -1)
const _hoisted_13 = {
  class: "text-left mt-n3 mb-3",
  key: "skaderErr"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg antal skader'
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: "RkiLabel",
  class: "pb-3 text-left"
}
const _hoisted_17 = {
  key: "rkiErr",
  class: "text-left"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg ja eller nej'
}, null, -1)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioComponent = _resolveComponent("RadioComponent")!
  const _component_SelectModalComponent = _resolveComponent("SelectModalComponent")!
  const _component_DatePickerComponent = _resolveComponent("DatePickerComponent")!
  const _component_SegmentedControlComponent = _resolveComponent("SegmentedControlComponent")!
  const _component_PopoverComponent = _resolveComponent("PopoverComponent")!
  const _component_ButtonTapComponent = _resolveComponent("ButtonTapComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.showInsuranceChoices && _ctx.showCommon)
      ? (_openBlock(), _createBlock(_TransitionGroup, {
          key: 0,
          name: "slide-simple"
        }, {
          default: _withCtx(() => [
            (_ctx.showInsuranceChoices && _ctx.showCommon)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", {
                    class: "pb-3 text-left",
                    innerHTML: _ctx.existingInsuranceLabel
                  }, null, 8, _hoisted_2),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jaNejArray, (item, inx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass([inx + 1 === _ctx.jaNejArray.length ? 'pb-3' : 'pb-2']),
                      key: 'existInsurance' + inx
                    }, [
                      _createVNode(_component_RadioComponent, {
                        name: 'existInsurance',
                        id: 'existInsurance' + item.value,
                        inputValue: item.value,
                        preSelect: _ctx.model.additionalInfo.existInsurance,
                        trackingLabel: _ctx.existingInsuranceLabel,
                        onRadioComponent: _ctx.handleRadioClick
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.displayValue), 1)
                        ]),
                        _: 2
                      }, 1032, ["id", "inputValue", "preSelect", "trackingLabel", "onRadioComponent"])
                    ], 2))
                  }), 128)),
                  (!_ctx.model.pristineStep.get(_ctx.card.name) && !_ctx.model.additionalInfo.existInsurance)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.model.additionalInfo.existInsurance === 'ja')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_SelectModalComponent, {
              key: "existingInsurance",
              id: "existingInsurance",
              name: "existingInsurance",
              preSelect: _ctx.model.additionalInfo.existingInsurance,
              innerData: _ctx.cms.insuranceCompanies,
              selected: _ctx.model.additionalInfo.existingInsurance !== undefined,
              placeholder: "Vælg forsikringsselskab",
              visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
              errorMsgOverride: "Du skal vælge et forsikringsselskab",
              "onSelectModalComponent:selected": _ctx.selectExistingInsurance
            }, null, 8, ["preSelect", "innerData", "selected", "visibleError", "onSelectModalComponent:selected"]), [
              [_vShow, _ctx.model.additionalInfo.existInsurance === 'ja']
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showCommon)
      ? (_openBlock(), _createBlock(_TransitionGroup, {
          key: 1,
          name: "slide-simple"
        }, {
          default: _withCtx(() => [
            (_ctx.showValidNowOption)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7))
              : _createCommentVNode("", true),
            (_ctx.showValidNowOption)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validNowArray, (item, inx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass([inx + 1 === _ctx.validNowArray.length ? 'pb-3' : 'pb-2']),
                      key: 'validNow' + inx
                    }, [
                      _createVNode(_component_RadioComponent, {
                        name: "validNow",
                        id: 'validNow' + item.value,
                        inputValue: item.value,
                        preSelect: _ctx.model.additionalInfo.validNow,
                        trackingLabel: "Hvornår skal forsikringen gælde fra?",
                        onRadioComponent: _ctx.handleRadioClick
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.displayValue), 1)
                        ]),
                        _: 2
                      }, 1032, ["id", "inputValue", "preSelect", "onRadioComponent"])
                    ], 2))
                  }), 128)),
                  (!_ctx.model.pristineStep.get(_ctx.card.name) && !_ctx.model.additionalInfo.validNow)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.model.additionalInfo.validNow === 'nej' && _ctx.showValidNowOption)
              ? (_openBlock(), _createBlock(_component_DatePickerComponent, {
                  key: "validFromDate",
                  class: "text-left mb-3",
                  label: "",
                  innerId: "validFromDate",
                  innerData: _ctx.model.additionalInfo,
                  placeholder: "F.eks. 21-12-2020",
                  validateOnLoad: !_ctx.model.pristineStep.get(_ctx.card.name),
                  validationRule: "AfterToday",
                  visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
                  dateLimitIncluded: true
                }, null, 8, ["innerData", "validateOnLoad", "visibleError"]))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_SegmentedControlComponent, {
              key: "skader",
              class: "pb-3",
              id: "skader",
              options: _ctx.skaderOptions,
              labels: _ctx.skaderLabels,
              preSelected: _ctx.model.additionalInfo.skader,
              controlsPerRow: 4,
              onSegmentedComponent: _ctx.handleRadioClick
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["options", "labels", "preSelected", "onSegmentedComponent"]), [
              [_vShow, !_ctx.model.multipleProducts && _ctx.isInsuranceInfoFilled]
            ]),
            (
					!_ctx.model.pristineStep.get(_ctx.card.name) &&
					!_ctx.model.multipleProducts &&
					_ctx.isInsuranceInfoFilled &&
					!_ctx.model.additionalInfo.skader
				)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", _hoisted_16, [
              _createElementVNode("span", null, _toDisplayString(_ctx.cms.rkiHeader), 1),
              (_ctx.cms.rkiPopover)
                ? (_openBlock(), _createBlock(_component_PopoverComponent, {
                    key: 0,
                    type: "icon",
                    class: "page-component__popover text-left",
                    buttonClass: "popover__icon popover__icon__questionmark",
                    innerData: _ctx.cms.rkiPopover
                  }, null, 8, ["innerData"]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, !_ctx.model.multipleProducts && _ctx.isInsuranceInfoFilled && _ctx.skaderOk]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jaNejArray, (item, inx) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([inx + 1 === _ctx.jaNejArray.length ? 'pb-3' : 'pb-2']),
                key: 'rki' + inx
              }, [
                _createVNode(_component_RadioComponent, {
                  name: "rki",
                  id: 'rki' + item.value,
                  inputValue: item.value,
                  preSelect: _ctx.model.additionalInfo.rki,
                  trackingLabel: _ctx.cms.rkiHeader,
                  onRadioComponent: _ctx.handleRadioClick
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.displayValue), 1)
                  ]),
                  _: 2
                }, 1032, ["id", "inputValue", "preSelect", "trackingLabel", "onRadioComponent"])
              ], 2)), [
                [_vShow, !_ctx.model.multipleProducts && _ctx.isInsuranceInfoFilled && _ctx.skaderOk]
              ])
            }), 128)),
            (!_ctx.model.pristineStep.get(_ctx.card.name) && _ctx.model.additionalInfo.rki === undefined)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19, 512)), [
                  [_vShow, !_ctx.model.multipleProducts && _ctx.isInsuranceInfoFilled && _ctx.skaderOk]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ButtonTapComponent, {
      class: _normalizeClass([_ctx.card.buttonStyle, 'mt-3', { 'btn-disabled': !_ctx.isValid }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextStep())),
      textContent: _toDisplayString(_ctx.getNextCardLinkText()),
      "data-gtm": _ctx.cms.dataGtm,
      "data-gtm-click-text": _ctx.card.routePath
    }, null, 8, ["class", "textContent", "data-gtm", "data-gtm-click-text"])
  ]))
}